import React from "react";

import { Container } from "react-bootstrap";

interface ContainerDividerComponentProps {
  title: string;
  class?: string;
}

const ContainerDivider: React.FC<ContainerDividerComponentProps> = (props) => (
  <Container fluid className={props.class ?? "container-divider"}>
    <h3 className="text-light m-0">{props.title}</h3>
  </Container>
);

export default ContainerDivider;
